import React, { Component } from 'react';
import './WizardHeader.css';
import { NavLink } from "react-router-dom";
import Tooltip from './Tooltip';
import FindIndex from './FindIndex';
import { withTranslation, Trans } from 'react-i18next';

class WizardHeader extends Component {

    renderTooltip(item) {
        return (
            <span>
                <span className="upperCase"><Trans defaults='Step' /> {item.index + 1}:</span><br />
                <b>{item.value.name}</b>
            </span>
        );
    }

    render() {
        const steps = this.props.steps;

        const navIndex = FindIndex(steps, s => s.url === this.props.currentStep);
        const prevStep = steps[Math.max(navIndex - 1, 0)];
        const nextStep = steps[Math.min(navIndex + 1, steps.length - 1)];

        return (
            <div className="wizardHeader">
                <NavLink className={"prev" + ((navIndex === 0) ? ' hidden' : '')} to={prevStep.url} />

                <div className="steps">
                    {this.props.steps.map((value, index) => {
                        return (
                            <Tooltip key={value.url} value={{value:value, index: index}} getContent={this.renderTooltip}>
                                <NavLink className={index < navIndex ? 'prev' : ''} to={value.url} />
                            </Tooltip>
                        );
                    })}
                </div>

                <span className="index">
                    {navIndex+1} / {steps.length}
                </span>

                <NavLink className={"next" + ((navIndex === steps.length - 1) ? ' hidden' : '')} to={nextStep.url} />
            </div>
        );
    }
}

export default withTranslation() (WizardHeader);


// WEBPACK FOOTER //
// ./src/WizardHeader.js